import React from 'react'
import { Box, Modal } from '@mantine/core'

export interface ImageLightboxProps {
  /** URL of the image to show. When null/undefined the lightbox is closed. */
  url: string | null | undefined;
  onClose: () => void;
  alt?: string;
}

/**
 * Standardized image lightbox. Clicking an image anywhere on the site should open it here so the
 * full, uncropped image is viewable in a large centered modal. Controlled by `url` (open when set).
 *
 * Usage:
 *   const [lightbox, setLightbox] = useState<string | null>(null)
 *   <img onClick={() => setLightbox(url)} style={{ cursor: 'zoom-in' }} />
 *   <ImageLightbox url={lightbox} onClose={() => setLightbox(null)} />
 */
export default function ImageLightbox ({ url, onClose, alt = '' }: ImageLightboxProps) {
  return (
    <Modal
      opened={!!url}
      onClose={onClose}
      size="xl"
      padding={0}
      withCloseButton
      centered
      styles={{
        content: { background: 'var(--gs-bg, #0d0d0d)', border: '1px solid var(--gs-border)' },
        close: { color: 'var(--gs-muted)', '&:hover': { background: 'var(--gs-surface2)' } }
      }}
    >
      {url && (
        <Box
          component="img"
          src={url}
          alt={alt}
          sx={{ display: 'block', width: '100%', height: 'auto', maxHeight: '88vh', objectFit: 'contain' }}
        />
      )}
    </Modal>
  )
}
